<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'breadcrumb',
})
</script>
<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-03-07 15:13:37
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-05-27 13:58:20
 * @FilePath: /qd-c4-yunjing-web/src/layouts/components/breadcrumb/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <el-breadcrumb
    v-if="breadcrumbList && breadcrumbList.length"
    separator="/"
    class="ma-bread-crumb"
  >
    <el-breadcrumb-item
      v-for="(item, index) in breadcrumbList"
      :key="item.path+index"
    >
      <span
        v-if="item.redirect === 'noRedirect' || index == breadcrumbList.length - 1"
      >
        {{ item.meta.title }}
      </span>
      <span
        v-else
        class="link"
        @click.prevent="linkHandle(item)"
      >
        {{ item.meta.title }}
      </span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script lang="ts" setup name="breadcrumb">
  import { ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useAppStore } from '@/store/app';

  const route = useRoute();
  const router = useRouter();

  const breadcrumbList:any = ref([]);
  const appStore = useAppStore();

  const props = defineProps({
    nbBreadcrumbs: {
      type: Array,
      default: () => [],
    },
  });

  const getBreadcrumbList = () => {
    // 如果有从外部传入的面包屑，优先使用
    if (props.nbBreadcrumbs && props.nbBreadcrumbs.length > 0) {
      breadcrumbList.value = props.nbBreadcrumbs;
      return;
    }

    // only show routes with meta.title
    const matched: any = route?.matched?.filter((item) => item.meta && item.meta.title) || [];
    let breadcrumbs = route?.meta?.breadcrumbs;
    if (matched.length === 0) {
      const currentMicroAppRoute = appStore.currentMicroAppRoute;
      breadcrumbs = currentMicroAppRoute?.meta?.breadcrumbs;
    }
    // 如果有自定义的面包屑，使用自定义的面包屑，否则使用自动生成的

    if (breadcrumbs) {
      breadcrumbList.value = breadcrumbs || [];
    } else {
      breadcrumbList.value = matched.filter((item: any) => {
        if (item.meta) {
          return item.meta.title && !item.meta.hideBreadcrumb;
        }
        return false;
      });
    }
  };

  watch(
    () => props.nbBreadcrumbs,
    () => {
      getBreadcrumbList();
    }, {
      immediate: true,
    }
  );

  watch(
    route,
    (val) => {
      if (val && !val.path.startsWith('/redirect/')) {
        getBreadcrumbList();
      }
    }, {
      immediate: true,
    }
  );

  const linkHandle = (val: any) => {
    /*
     * const { redirect, path, query } = val;
     * if (redirect) {
     *   router.push(redirect);
     *   return;
     * }
     * router.push({
     *   path,
     *   query,
     * });
     */
  };
</script>
<style>
.ma-bread-crumb{
  display: flex;
}

.link{
  font-weight: 600;
}
</style>
